<nx-default-box-v2>

  <!-- label -->
  <ng-template nxTemplate="label">
    <div class="text-[1rem] font-medium leading-3r mt-[2px]">
    Labels
    <p-progressSpinner
      ariaLabel="loading"
      *ngIf="isLoading"
      styleClass="ml-[6px] w-[16px] h-[16px] black-spinner"
      strokeWidth="8"/>
    </div>
  </ng-template>
  
  <!-- content -->
  <ng-container [ngTemplateOutlet]="editMode ? editTemplate : displayTemplate"></ng-container>
  
  <!-- actions -->
  <ng-template nxTemplate="mainEnd">
    <ng-container [ngTemplateOutlet]="editMode ? editActionsTemplate : displayActionsTemplate"></ng-container>
  </ng-template>
</nx-default-box-v2>

<!-- content view mode -->
<ng-template #displayTemplate>
  <div class="flex items-center gap-2 flex-wrap">
    <ng-container *ngFor="let label of activeLabels">
      <app-label [label]="label"></app-label>
    </ng-container>
    <div *ngIf="!activeLabels || activeLabels.length === 0">-</div>
  </div>
</ng-template>

<!-- content edit mode -->
<ng-template #editTemplate>
  <div class="mt-1 form" [formGroup]="form">
    <nx-edit-multiselect-v2-input
      [formGroup]="form"
      [placeholder]="placeholder"
      #selectComponent  
      formControlName="selected"  
      [options]="options"
      [panelWidhtFull]="true"
      [showLabel]="false"
      [maxSelectedLabels]="3"
      [optionLabel]="'scopedName'"
      [dataKey]="'id'"
      [label]="'label'">
      <ng-template nxTemplate="item" let-item>
        <div class="flex items-center gap-2" style="max-width: 250px; width: 250px;">
          <span class="border h-3 w-5 shrink-0 rounded bg-[rgb(255,0,0)] border-white" [ngStyle]="{ 'background': item.color }"></span>
          <span style="word-break: break-all; overflow-wrap: break-word; white-space: normal; flex: 1; min-width: 0;">{{ item.scopedName }}</span>
        </div>
      </ng-template>
    </nx-edit-multiselect-v2-input>
  </div>
</ng-template>

<ng-template #displayActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    (click)="edit()"
    [icon]="'icon-edit'"
    [tooltip]="'Bearbeiten'">
  </nx-default-button>
</ng-template>

<ng-template #editActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    class="mr-1"
    (click)="save()"
    [disabled]="isLoading || form?.pristine"
    [icon]="'icon-check'"
    [tooltip]="'Speichern'">
  </nx-default-button>
  <nx-default-button
    [style]="'dark'"
    (click)="cancel()"
    [disabled]="isLoading"
    [icon]="'icon-cancel'"
    [tooltip]="'Abbrechen'">
  </nx-default-button>
</ng-template>
